import { pxToRem, theme } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const balloonToolbarStyles = css `
  .ck.ck-balloon-panel {
    border: none;
    box-shadow: none;

    &.ck-tooltip {
      padding: ${theme.spacing.sm} ${theme.spacing.lg};
      border-radius: ${theme.borderRadius.md};
      background-color: ${theme.semantic.surface.inverseRaised};
    }

    &.ck-toolbar-container {
      background: transparent;

      &::before {
        display: none;
      }
    }

    &.ck-toolbar-container[class*='arrow_n']::after {
      border-bottom-color: ${theme.swatches.gray[1000]};
    }

    &.ck-toolbar-container[class*='arrow_s']::after {
      border-top-color: ${theme.swatches.gray[1000]};
    }

    .ck-balloon-rotator:has(.ck-table-form),
    .ck-balloon-rotator:has(.ck-link-form) {
      border: solid ${pxToRem(1)} ${theme.semantic.border.default};
      background-color: ${theme.semantic.surface.primary};
      box-shadow: ${theme.dropShadow[200]}, ${theme.dropShadow[300]};
    }

    .ck-toolbar:not(.ck-toolbar_compact) {
      border-radius: ${theme.borderRadius.lg};
      background-color: ${theme.semantic.surface.inverse};
      box-shadow: ${theme.dropShadow[200]}, ${theme.dropShadow[300]};

      &.ck-rounded-corners {
        border-radius: ${theme.borderRadius.md};
      }

      .ck-toolbar__separator {
        background-color: ${theme.swatches.gray[800]};
      }

      .ck-dropdown {
        .ck-splitbutton,
        .ck-splitbutton_flatten {
          &:not(.ck-disabled) {
            &:hover button {
              background-color: ${theme.semantic.surface.inverseRaised};
            }

            & .ck-splitbutton__action {
              border-top-right-radius: unset;
              border-bottom-right-radius: unset;
            }

            & .ck-splitbutton__arrow {
              border-top-left-radius: unset;
              border-bottom-left-radius: unset;
              border-width: ${pxToRem(1)};

              &::after {
                display: none;
              }
            }
          }

          &.ck-splitbutton_open > button:not(.ck-disabled) {
            border-color: ${theme.swatches.gray[900]};
            background-color: ${theme.semantic.surface.inverseRaised};
          }

          &.ck-splitbutton_open > .ck-button:not(.ck-on, .ck-disabled, :hover) {
            border-color: ${theme.swatches.gray[900]};
            background-color: ${theme.semantic.surface.inverseRaised};
          }
        }

        .ck-dropdown__panel {
          border-color: ${theme.swatches.gray[900]};
          background-color: ${theme.semantic.surface.inverse};

          .ck-list {
            background-color: inherit;

            .ck-list__separator {
              background-color: ${theme.semantic.surface.inverseRaised};
            }

            .ck-list__item {
              .ck-button:not(.ck-list-item-button, .ck-disabled) {
                &:focus {
                  background-color: ${theme.semantic.surface.inverse};
                }

                &:hover,
                &:active {
                  color: ${theme.swatches.gray[50]};
                  background-color: ${theme.semantic.surface.inverseRaised};
                }
              }

              .ck-list-item-button:not(.ck-disabled):hover {
                color: ${theme.swatches.gray[50]};
                background-color: ${theme.semantic.surface.inverseRaised};
              }

              .ck-switchbutton.ck-on,
              .ck-switchbutton.ck-off {
                border-color: transparent;
                color: ${theme.swatches.gray[100]};
                background-color: ${theme.semantic.surface.inverseRaised};
              }
            }
          }
        }
      }

      & button {
        outline: none;
        background: inherit;
        color: ${theme.swatches.gray[100]};
        border-radius: ${theme.borderRadius.md};
        transition: background-color 200ms ease-in-out;

        .ck-icon {
          color: ${theme.swatches.gray[100]};
        }

        &:focus,
        &:active {
          border-color: transparent;
          box-shadow: none;
        }

        &:not(.ck-disabled),
        &:not(.ck-off) {
          cursor: pointer;

          &:hover {
            color: ${theme.swatches.gray[50]};
            background-color: ${theme.semantic.surface.inverseRaised};
          }
        }
      }
    }
  }
`;
